export var GradeSyncEntryStatus;
(function (GradeSyncEntryStatus) {
    GradeSyncEntryStatus["SUCCESS"] = "Success";
    GradeSyncEntryStatus["FAILED"] = "Failed";
    GradeSyncEntryStatus["STARTED"] = "Started";
    GradeSyncEntryStatus["SUBMITTED"] = "Submitted";
    GradeSyncEntryStatus["PARTIALLY_COMPLETE"] = "PartiallyComplete";
})(GradeSyncEntryStatus || (GradeSyncEntryStatus = {}));
//# sourceMappingURL=IGradeSyncStatus.js.map